import { gql } from "@apollo/client";

export const CREATE_LOCK_NOTE = gql`
mutation createLockNote($reason: String!, $customerid: String!) {
  createLockNote(reason: $reason, customerid: $customerid) {
    status
    error
    locknote {
      locknoteid
      reason
      islock
      user {
        userid
        name
      }
    }
  }
}`;